import { templates as layouts } from "./components/Layout";
import { templates as pages } from "./components/pages";
import { templates as addons } from "./components/addons";

const templates = [
    ...layouts,
    ...pages,
    ...addons,
];

export default templates;